<medrecord-auth-twofa-enter-code
  [flow]="flow$ | async"
  (submitCode)="submitCode($event)"
>
</medrecord-auth-twofa-enter-code>